import { Image, ImageProps } from "@chakra-ui/react";
import logo from "assets/images/logo.png";
import { FC } from "react";

export const Logo: FC<ImageProps> = (props) => <Image w={130} h="44px" {...props} src={logo} />;
